<template>
  <div
    class="flex max-h-[25%] min-h-[25%] w-[90%] items-center justify-center rounded-lg bg-white bg-opacity-5"
  >
    <div class="flex h-full w-full flex-row items-center justify-center">
      <div
        :class="locale === 'ar' ? 'flex-row-reverse' : 'flex-row'"
        class="flex h-full w-[90%] items-center justify-center"
      >
        <div class="relative flex h-[90%] w-[25%] items-center justify-center">
          <div class="relative flex h-full w-full items-center justify-center">
            <div
              class="relative box-border flex h-[17vmin] w-[17vmin] items-center justify-center overflow-hidden rounded-full md:h-[27vmin] md:w-[27vmin]"
            >
              <img
                class="h-full w-full object-fill"
                src="../assets/spottyBackground.png"
                alt="Background Image"
              />
              <img
                class="absolute h-full w-full rounded-full border-2 object-fill"
                :src="player?.image || blankPlayerImage"
                alt="Player Image"
              />
            </div>
          </div>
        </div>
        <div class="h-[90%] w-[50%] text-white">
          <div
            :class="
              locale === 'ar' ? 'pr-[5%] justify-end' : 'pl-[5%] justify-start'
            "
            class="flex h-[33%] w-full items-center pr-[5%] text-[3vw] font-bold"
          >
            {{ formatName(player) || "-" }}
          </div>
          <div
            :class="
              locale === 'ar' ? 'pr-[5%] items-end' : 'pl-[5%] items-start'
            "
            class="flex h-[66%] flex-col justify-evenly text-[2vw]"
          >
            <div class="text-slate-300">
              {{ player?.Position || "-" }}
            </div>
            <div class="text-slate-300">
              {{ locale === "ar" ? player?.Caps || "-" : $t("caps") }}
              <span class="text-white">{{
                locale === "ar" ? $t("caps") : player?.Caps || "-"
              }}</span>
            </div>
            <div class="text-slate-300">
              {{
                locale === "ar"
                  ? calculateWorldCups(player) || "-"
                  : $t("appearances")
              }}
              <span class="text-white">{{
                locale === "ar"
                  ? $t("appearances")
                  : calculateWorldCups(player) || "-"
              }}</span>
            </div>
          </div>
        </div>
        <div class="flex h-[90%] w-[10.5%] items-start justify-center">
          <div
            @click="captain(player)"
            :class="[
              player ? 'block' : 'hidden',
              captainId === player?.id ? 'bg-saudi-purple ' : 'bg-slate-500',
            ]"
            class="mt-[15%] flex h-[7vmin] w-[7vmin] items-center justify-center rounded-full border-2 bg-black"
          >
            <div
              class="flex h-[80%] w-[80%] items-center justify-center rounded-full font-bold text-white"
            >
              <h1
                :class="{
                  'text-[0.8vw]': locale === 'ar',
                  'text-[3vw]': locale !== 'ar',
                }"
                class="mr-[2%] text-white"
              >
                {{ locale === "ar" ? "قائد الفريق" : "C" }}
              </h1>
            </div>
          </div>
        </div>
        <div class="flex h-[90%] w-[12.5%] items-center justify-center">
          <button
            @click="addPlayerToTeam(player)"
            :disabled="!player"
            class="h-[80%] w-[85%] rounded-lg bg-saudi-purple text-3xl"
          >
            +
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import blankPlayerImage from "../assets/blankPlayer.png";
import { useI18n } from "vue-i18n";

const { locale } = useI18n();
const oldCaptianId = ref(0);
const emit = defineEmits(["addPlayerToTeam"]);
const correctPlayer = ref(null);
const playerTest = ref(null);

const props = defineProps({
  player: Object,
  playerData: Object,
  captainId: Number,
});


watch(
  () => props.player,
  (newPlayer) => {
    playerTest.value = null;
    correctPlayer.value = newPlayer;
    findPlayer();
  }
);

const findPlayer = () => {
  if (props.player) {
    playerTest.value =
      props.playerData.find((player) => player.id === correctPlayer.value.id) ||
      null;
  }
};

const calculateWorldCups = (data) => {
  const worldCupsArray = data?.WorldCups;
  return worldCupsArray
    ? worldCupsArray.map((wc) => "‘" + wc.slice(-2)).join(" ")
    : "-";
};

const formatName = (name) => {
  const firstName = name?.Given_name;
  const lastName = name?.Family_name;

  const formattedFirstName = firstName
    ? firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase()
    : "";
  const formattedLastName = lastName
    ? lastName
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ")
    : "";
  if (locale.value === "ar") {
    return `${formattedLastName} ${formattedFirstName} `.trim();
  } else return `${formattedFirstName} ${formattedLastName}`.trim();
};

const captain = (player) => {
  if (player.id === oldCaptianId.value) {
    emit("addCaptain", 100);
    oldCaptianId.value = null;
  } else {
    emit("addCaptain", player.id);
    oldCaptianId.value = player.id;
  }
};

const addPlayerToTeam = (player) => {
  emit("addPlayerToTeam", player);
};
</script>
